import { VStack } from 'native-base'
import React, { } from 'react'
import { useParams } from 'react-router-dom'
import CompHeader from '../../commons/CompHeader/CompHeader'
import Loading from '../../commons/Loading'
import useFetch from '../../hook/useFetch'
import { getStoreSubscriptionsById } from '../../apis/admin';
import CreateSubscriptions from './CreateStoreSubscriptions';

const EditStoreSubscriptions = () => {
    const { id } = useParams()

    const { data, isLoading } = useFetch({
        name: `getsubscriptionsbyid_${id}`,
        service: getStoreSubscriptionsById,
        id
    })


    return (
        <VStack p='3' space='2' w={'100%'} maxW={500}>
            <CompHeader title='Edit Subscription' backButton />
            {isLoading ? <Loading /> :
                <CreateSubscriptions data={data} />}
        </VStack>
    )
}

export default EditStoreSubscriptions